// -------------------------------------
// Import from NPM
// -------------------------------------
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Input, Button, List, Icon } from "semantic-ui-react";
import _ from "lodash";
import { Div } from "@components/Generics.react";

// -------------------------------------
// Import APIs
// -------------------------------------
import { useGetSearchesQuery } from "@api/apiV6";

// -------------------------------------
// Import Styles
// -------------------------------------
import "@styles/components.scss";

// -------------------------------------
// Constants
// -------------------------------------
const stopWords = ["the", "a", "an", "and"];

export default function SearchBar(props) {
    const { noSuggestions = false } = props;
    const navigate = useNavigate();
    const articles = useSelector((state) => state.articles.list);
    const [searchText, setSearchText] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const { data: searches, isSuccess: serchesFetched } = useGetSearchesQuery();
    const oldsearches = serchesFetched ? searches.map(({ term }) => term) : [];

    let allArticles = _.map(articles, (article) => {
        return {
            id: article._id,
            name: article.name,
            tags: article.tags,
        };
    });

    useEffect(() => {
        document.addEventListener("mouseup", function (e) {
            var container = document.getElementById(
                "searchbar-suggestion-list"
            );
            if (container && !container.contains(e.target)) {
                container.style.display = "none";
            }
        });
    }, []);

    const handleSearch = (e) => {
        if (e.key === "Enter") {
            if (searchText.length > 2) setSearchText("");
            setSuggestions([]);
            let url = `/search?text=${searchText}`;
            if (searchText.startsWith("#")) {
                let tag = searchText.replace("#", "").split(" ").join("_");
                url = `/search?tag=${tag}`;
            }
            navigate(url);
        } else {
            setSearchText(e.target.value);
        }
    };

    const handleSuggestionClick = (i) => {
        const searchValue = suggestions[i];
        setSearchText("");
        setSuggestions([]);

        let url = `/search?text=${searchValue}`;
        if (searchValue.startsWith("#")) {
            let tag = searchValue.replace("#", "").split(" ").join("_");
            url = `/search?tag=${tag}`;
        }
        navigate(url);
    };

    const handleSearchChange = ({ target: { value } }) => {
        setSearchText(value);
        if (value.length >= 3) {
            const suggestions = getSuggestions(value);
            setSuggestions(suggestions);
        }
    };

    const getSuggestions = (query) => {
        if (query && query.trim() !== "") {
            let suggestions = [];
            allArticles.forEach((article) => {
                if (suggestions.length <= 10) {
                    let articleName = article.name;
                    if (
                        articleName &&
                        articleName.toLowerCase().includes(query.toLowerCase())
                    ) {
                        let articleNameArr = articleName
                            .replace(/[^a-zA-Z0-9 ]/g, "")
                            .split(" ");
                        articleNameArr.forEach((word) => {
                            if (
                                !stopWords.includes(word.trim()) &&
                                word
                                    .toLowerCase()
                                    .includes(query.toLowerCase()) &&
                                !suggestions.includes(word)
                            ) {
                                suggestions.push(word);
                            }
                        });

                        let articleTags = article.tags;

                        if (articleTags) {
                            articleTags.forEach((tag) => {
                                let tagName = tag.name;
                                let item = "#" + tagName;
                                if (
                                    !stopWords.includes(tagName.trim()) &&
                                    tagName
                                        .toLowerCase()
                                        .includes(query.toLowerCase()) &&
                                    !suggestions.includes(item)
                                ) {
                                    suggestions.push(item);
                                }
                            });
                        }
                    }
                }
            });

            if (oldsearches) {
                oldsearches.forEach((term) => {
                    if (
                        term.toLowerCase().includes(query.toLowerCase()) &&
                        !suggestions.includes(term)
                    ) {
                        suggestions.push(term);
                    }
                });
            }
            return suggestions;
        }
        return [];
    };

    //----------------------------------------------
    // Views
    //----------------------------------------------
    const SuggestionList = ({ items }) => {
        return (
            <List
                id="searchbar-suggestion-list"
                divided
                verticalAlign="middle"
                className="suggestion-list"
            >
                {items.map((item, i) => {
                    return (
                        <Suggestion
                            value={item}
                            onClick={(event) => handleSuggestionClick(i, event)}
                            key={i}
                        />
                    );
                })}
            </List>
        );
    };

    const Suggestion = ({ value, onClick }) => {
        let isTag = value.startsWith("#");
        let label = isTag ? value.slice(1) : value;
        return (
            <List.Item onClick={onClick} className="suggestion-list-item">
                {isTag && <Icon color="yellow" name="tag" />}
                {label}
            </List.Item>
        );
    };

    return (
        <Div className="search-bar">
            <Input
                placeholder="Search..."
                labelPosition="right"
                onChange={handleSearchChange}
                onKeyUp={handleSearch}
                value={searchText}
                className="search-input"
            />
            <Button icon="search" className="search-action"></Button>

            {suggestions && suggestions.length > 0 && !noSuggestions && (
                <SuggestionList items={suggestions} />
            )}
        </Div>
    );
}
